import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ExitIcon from '@mui/icons-material/ExitToApp';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InventoryIcon from '@mui/icons-material/Inventory';
import MenuIcon from '@mui/icons-material/Menu';
import Add from '@mui/icons-material/AddCircle';
import logo from '../assets/logo.png';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useApp } from '../context/AppContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
    Avatar,
    IconButton,
    LinearProgress,
    Menu,
    MenuItem,
    Stack,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { useState } from 'react';
import logo_cinza from '../assets/logo_branca.png';
import { CalendarMonth, Person, Gavel, SupportAgent, EventAvailable, CoPresent } from '@mui/icons-material';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import SininhoDeAvisos from './SininhoDeAvisos';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

/**
 * Etiqueta de papel que aparece embaixo do nome.
 *
 * Anfitriao pendente precisa se distinguir do aprovado: ate a analise passar,
 * os encontros dele nao aparecem para os outros usuarios. `approved` e nullable
 * no banco, entao qualquer valor que nao seja true conta como pendente.
 */
const LARANJA_PENDENTE = '#ed6c02';

const papelDoUsuario = user => {
    if (!user?.profile) return { rotulo: 'Conviva', pendente: false };

    return user.profile.approved === true
        ? { rotulo: 'Anfitrião', pendente: false }
        : { rotulo: 'Anfitrião - Pendente', pendente: true };
};

const AppBarAdmin = ({ setOpenMenu }) => {
    const { LogOut, user } = useAuth();
    const { pathname } = useLocation();
    const navigation = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('md'));
    const papel = papelDoUsuario(user);

    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <AppBar position="sticky">
            <Toolbar>
                <Stack
                    flexDirection="row"
                    alignItems="center"
                    onClick={e => {
                        if (Boolean(user?.profile)) {
                            navigation('/calendario');
                        } else {
                            navigation('/lista');
                        }
                    }}
                    gap={2}
                    sx={{ flexGrow: 1, cursor: 'pointer' }}>
                    <Box
                        sx={{ display: 'inline-block', width: 35, height: 35 }}
                        component="img"
                        src={logo_cinza}
                    />
                    <Typography variant="h6" sx={{ lineHeight: 0.9, marginLeft: '-7.5px' }}>
                        Empiria
                    </Typography>
                </Stack>

                {!mobile && (
                    <>
                        {Boolean(user?.profile) && (
                            <Button
                                onClick={() => navigation('/meus-encontros/novo')}
                                variant="outlined"
                                sx={{ color: '#fff', marginRight: 1 }}
                                startIcon={<Add />}>
                                Novo encontro
                            </Button>
                        )}
                        {/* <Button
                            onClick={() => navigation('/encontrar')}
                            variant="text"
                            sx={{color: '#fff', marginRight: 1}}
                            startIcon={<InventoryIcon />}>
                            Encontrar
                        </Button> */}
                        <Button
                            onClick={() => navigation('/lista')}
                            variant="text"
                            sx={{ color: '#fff', marginRight: 1 }}
                            startIcon={<DashboardIcon />}>
                            Encontros
                        </Button>
                        <Button
                            onClick={() => navigation('/calendario')}
                            variant="text"
                            sx={{ color: '#fff', marginRight: 1 }}
                            startIcon={<CalendarMonth />}>
                            Agenda
                        </Button>
                        {/* {Boolean(user.profile) && (
                            <Button
                                onClick={() => navigation('/meus-encontros')}
                                variant="text"
                                sx={{color: '#fff', marginRight: 1}}
                                startIcon={<CalendarMonth />}>
                                Agenda
                            </Button>
                        )} */}
                        {/* {Boolean(user.profile) && (
                            <Button
                                onClick={() => navigation('/perfil')}
                                variant="text"
                                sx={{color: '#fff', marginRight: 1}}
                                startIcon={<UserIcon />}>
                                Meu perfil
                            </Button>
                        )} */}
                        {/*<Button
                            onClick={() => navigation('clientes')}
                            variant="text"
                            sx={{color: '#fff', marginRight: 1}}
                            startIcon={<CustomerIcon />}>
                            Clientes
                        </Button>
                        <Button
                            onClick={() => navigation('usuarios')}
                            variant="text"
                            sx={{color: '#fff', marginRight: 1}}
                            startIcon={<UsersIcon />}>
                            Usuários
                        </Button> */}
                    </>
                )}
                {mobile ? (
                    <IconButton
                        onClick={() => setOpenMenu(true)}
                        size="large"
                        edge="end"
                        color="inherit"
                        aria-label="menu">
                        <MenuIcon />
                    </IconButton>
                ) : (
                    <Stack direction="row" alignItems="center" gap={1} ml={3}>
                        <Stack justifyContent="center" alignItems="flex-end">
                            <Typography>{Boolean(user.name) && user.name.split(' ', 1)}</Typography>
                            <Typography
                                sx={{
                                    backgroundColor: papel.pendente ? LARANJA_PENDENTE : '#fff',
                                    borderRadius: 1,
                                    fontSize: 11,
                                    color: papel.pendente ? '#fff' : 'black',
                                    fontWeight: papel.pendente ? 600 : 400,
                                    padding: '1px 4px',
                                    whiteSpace: 'nowrap',
                                }}>
                                {papel.rotulo}
                            </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="center">
                            <SininhoDeAvisos />
                            <IconButton
                                onClick={handleClick}
                                aria-controls={open ? 'account-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}>
                                <Avatar sx={{ width: 42, height: 42 }} src={user.profileImage} />
                                <ArrowDropDownIcon />
                            </IconButton>
                        </Stack>
                        <Menu
                            anchorEl={anchorEl}
                            id="account-menu"
                            open={open}
                            onClose={handleClose}
                            onClick={handleClose}
                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
                            <MenuItem onClick={e => navigation('/meuperfil')}>Meu perfil</MenuItem>
                            {!Boolean(user.profile) && (
                                <MenuItem divider onClick={e => navigation('/perfil?sign=encontrado')}>
                                    Me tornar anfitrião
                                </MenuItem>
                            )}
                            <MenuItem onClick={() => navigation('/chat-bot')}>Suporte</MenuItem>
                            <MenuItem onClick={() => navigation('/conversas')}>Conversas</MenuItem>
                            <MenuItem onClick={() => navigation('/atendimento')}>Falar com a equipe</MenuItem>
                            <MenuItem onClick={() => navigation('/politicas')}>Termos e Políticas</MenuItem>
                            <MenuItem
                                divider
                                onClick={() => {
                                    LogOut();
                                    navigation('/');
                                }}>
                                Sair
                            </MenuItem>
                            <MenuItem>
                                <Typography sx={{ fontSize: 10 }}>
                                    Versão {localStorage.getItem('current_version')}
                                </Typography>
                            </MenuItem>
                        </Menu>
                    </Stack>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default props => {
    const { loading } = useApp();

    const { LogOut, user } = useAuth();
    const navigation = useNavigate();
    const [openMenu, setOpenMenu] = useState(false);
    const papel = papelDoUsuario(user);

    return (
        <>
            <AppBarAdmin setOpenMenu={setOpenMenu} />
            {loading && <LinearProgress variant="indeterminate" />}
            <Drawer anchor="right" open={openMenu} onClose={() => setOpenMenu(false)}>
                <Box sx={{ width: 280 }} role="presentation" onClick={() => setOpenMenu(false)}>
                    {/* Perfil do usuario */}
                    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ p: 2, pb: 1.5 }}>
                        <Avatar sx={{ width: 48, height: 48 }} src={user?.profileImage} />
                        <Stack>
                            <Typography fontWeight={600} fontSize={15}>
                                {user?.name}
                            </Typography>
                            <Typography
                                sx={{
                                    backgroundColor: papel.pendente ? LARANJA_PENDENTE : '#006a61',
                                    borderRadius: 1,
                                    fontSize: 11,
                                    color: '#fff',
                                    fontWeight: papel.pendente ? 600 : 400,
                                    padding: '1px 6px',
                                    width: 'fit-content',
                                }}>
                                {papel.rotulo}
                            </Typography>
                        </Stack>
                    </Stack>
                    <Divider />

                    {/* Navegacao */}
                    <List>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => navigation('/meuperfil')}>
                                <ListItemIcon><Person /></ListItemIcon>
                                <ListItemText primary="Meu perfil" />
                            </ListItemButton>
                        </ListItem>
                        {Boolean(user?.profile) && (
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => navigation('/meus-encontros/novo')}>
                                    <ListItemIcon><Add /></ListItemIcon>
                                    <ListItemText primary="Criar encontro" />
                                </ListItemButton>
                            </ListItem>
                        )}
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => navigation('/lista')}>
                                <ListItemIcon><DashboardIcon /></ListItemIcon>
                                <ListItemText primary="Encontros" />
                            </ListItemButton>
                        </ListItem>
                        {/* Vieram dos balões do topo da lista de encontros, que
                            no celular ocupavam a tela toda */}
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => navigation('/acompanhando')}>
                                <ListItemIcon><NotificationsNoneOutlinedIcon /></ListItemIcon>
                                <ListItemText primary="Anfitriões que acompanho" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => navigation('/encontros')}>
                                <ListItemIcon><EventAvailable /></ListItemIcon>
                                <ListItemText primary="Encontros comprados/agendados" />
                            </ListItemButton>
                        </ListItem>
                        {Boolean(user?.profile) && (
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => navigation('/meus-encontros')}>
                                    <ListItemIcon><CoPresent /></ListItemIcon>
                                    <ListItemText primary="Encontros criados" />
                                </ListItemButton>
                            </ListItem>
                        )}
                        {/* "Calendário" dos balões e a mesma tela desta Agenda */}
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => navigation('/calendario')}>
                                <ListItemIcon><CalendarMonth /></ListItemIcon>
                                <ListItemText primary="Agenda" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                    <Divider />

                    {/* Opcoes de conta */}
                    <List>
                        {!Boolean(user?.profile) && (
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => navigation('/perfil?sign=encontrado')}>
                                    <ListItemIcon><Add /></ListItemIcon>
                                    <ListItemText primary="Me tornar anfitrião" />
                                </ListItemButton>
                            </ListItem>
                        )}
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => navigation('/conversas')}>
                                <ListItemIcon><ChatBubbleOutlineIcon /></ListItemIcon>
                                <ListItemText primary="Conversas" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => navigation('/atendimento')}>
                                <ListItemIcon><HeadsetMicIcon /></ListItemIcon>
                                <ListItemText primary="Falar com a equipe" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => navigation('/chat-bot')}>
                                <ListItemIcon><SupportAgent /></ListItemIcon>
                                <ListItemText primary="Suporte" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => navigation('/politicas')}>
                                <ListItemIcon><Gavel /></ListItemIcon>
                                <ListItemText primary="Termos e Políticas" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => { LogOut(); navigation('/'); }}>
                                <ListItemIcon><ExitIcon /></ListItemIcon>
                                <ListItemText primary="Sair" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                    <Divider />
                    <Typography sx={{ fontSize: 10, color: 'text.secondary', p: 2 }}>
                        Versão {localStorage.getItem('current_version')}
                    </Typography>
                </Box>
            </Drawer>
        </>
    );
};
